import React, { useEffect, useState } from "react";

import { Box, Divider, Skeleton, Typography, Grid } from "@mui/material";
import CloseEnquiryDialog from "./CloseEnquiryDialog";
import { StyledDeliverySectionBox } from "./StyledDeliverySectionBox";
import { StyledDeliverySectionTextPrimary } from "./StyledDeliverySectionTextPrimary";
import { OfferDetails } from "./OfferDetails";
import { LOADING_STATUS } from "../../constants/constant";
import {
  closeEnquiry,
  getCustomerEnquiryDetailsById,
} from "../../api/Customer/enquiry";
import { useSelector, useDispatch } from "react-redux";
import ErrorScreen from "../Common/ErrorScreen";
import { setEnquiryStatusTracking } from "../../redux/slices/customerSlice";

export const OfferReceivedCollapse = ({ enquiry, handleOpenToast }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [enquiryDetails, setEnquiryDetails] = useState({});
  const [enquiryDetailsFetched, setIsEnquiryDetailsFetched] = useState("");
  const dispatch = useDispatch();

  const customerId = useSelector((state) => state.customer.id);
  const enquiryStatusTracking = useSelector(
    (state) => state.customer.enquiryStatusTracking
  );
  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleCloseEnquiry = async () => {
    var enquiryId = enquiryDetails?.enquiryId;
    try {
      const response = await closeEnquiry(customerId, enquiryId);
      if (response.status === 200) {
        handleCloseDialog();
        handleOpenToast("Enquiry closed successfully!", "success");

        await new Promise((resolve) => setTimeout(resolve, 3000));
        dispatch(setEnquiryStatusTracking(`${enquiryId}-enquiry-closed`));
      }
    } catch (error) {
      handleOpenToast(`Error while closing enquiry!`, "error");
    } finally {
      setIsDialogOpen(false);
    }
  };

  const fetchCustomerEnquiryDetails = async () => {
    try {
      setIsEnquiryDetailsFetched(LOADING_STATUS.LOADING);
      const response = await getCustomerEnquiryDetailsById(
        customerId,
        enquiry?.enquiryId
      );
      if (response.status === 200) {
        const details = response?.data.data.enquiry;
        setEnquiryDetails(details);
        setIsEnquiryDetailsFetched(LOADING_STATUS.LOADED);
      }
    } catch (error) {
      setIsEnquiryDetailsFetched(LOADING_STATUS.FAILED);
    }
  };

  useEffect(() => {
    fetchCustomerEnquiryDetails();
  }, [enquiryStatusTracking]);

  if (enquiryDetailsFetched === LOADING_STATUS.LOADED) {
    return (
      <>
        <Box
          sx={{
            background: "#DDEFDD",
            padding: "16px 24px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={4} sx={{ whiteSpace: "normal" }}>
              <StyledDeliverySectionBox>
                <StyledDeliverySectionTextPrimary>
                  {enquiryDetails?.pickup?.location?.address}
                </StyledDeliverySectionTextPrimary>
              </StyledDeliverySectionBox>
            </Grid>
            <Grid item xs={4}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                px={2}
              >
                <Typography sx={{ fontSize: 12, fontWeight: 400 }}>
                  {`${enquiryDetails?.distance}km`}
                </Typography>
                <img src="/assets/icons/distanceArrowLong.svg" alt="distance" />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <StyledDeliverySectionBox sx={{ alignItems: "end" }}>
                <StyledDeliverySectionTextPrimary
                  sx={{ textAlign: "right", wordWrap: "break-word" }}
                >
                  {`${enquiryDetails?.dropoff?.location?.address}`}
                </StyledDeliverySectionTextPrimary>
              </StyledDeliverySectionBox>
            </Grid>
          </Grid>
          <Box
            display="flex"
            sx={{
              width: "100%",
            }}
            alignItems="center"
            justifyContent="space-between"
          ></Box>

          <Box sx={{ padding: "12px 8px" }}>
            <Typography
              onClick={handleOpenDialog}
              sx={{
                color: "#FF3F3F",
                fontSize: 14,
                fontWeight: 400,
                textDecoration: "underline",
                cursor: "pointer",
                display: "inline",
              }}
            >
              Close Enquiry
            </Typography>
          </Box>

          <Divider
            sx={{
              mx: 1,
              color: "#6D6D6D",
              fontWeight: 700,
              opacity: 1,
              height: 1,
            }}
          />

          <OfferDetails
            enquiry={enquiry}
            enquiryDetails={enquiryDetails}
            handleOpenToast={handleOpenToast}
          />
        </Box>
        <CloseEnquiryDialog
          enquiryDetails={enquiryDetails}
          open={isDialogOpen}
          handleClose={handleCloseDialog}
          handleCloseEnquiry={handleCloseEnquiry}
        />
      </>
    );
  } else if (enquiryDetailsFetched === LOADING_STATUS.FAILED) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <ErrorScreen onRetry={fetchCustomerEnquiryDetails} />;
      </Box>
    );
  } else {
    return (
      <Box sx={{ width: "100%" }} p={3}>
        <Skeleton />
        <Skeleton animation="wave" />
        <Skeleton animation={false} />
        <Skeleton animation="wave" />
      </Box>
    );
  }
};
